<template>

  <div class="bg-grey vh-100">
    <div id="loadingPage">
      <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
    </div>
    <div id="loadingPageExportLayanan" v-if="ekspor.onprogress == 1">
      <div class="fullpageLoading">
        <div class="d-block">
          <center>
            <span class="spinner-border spinner-border-sm-loader m-0" role="status" aria-hidden="true"></span>
            <h5 style="margin-top:15px">Mohon tunggu, sedang mengekspor {{ ekspor.progress_looping }} dari {{ ekspor.lenght }} Data</h5>
            <div>
              <a :href="ekspor.exportlink" v-if="ekspor.exportlink!==''" ref="eksporlink">Download File Ekspor Disini</a>
            </div>
          </center>
        </div>
      </div>
    </div>
    <div class="bg-grey vh-100" id="listkaryawan_Absensi">

      <!-- HEADER -->
      <div class="header-top tabbed bg-white pageDefault" v-if="ekspor.onprogress == 0">
        <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
          <div class="header-top--left">
            <div class="header-item" @click="dashboard">
              <img src="../../assets/icons/back-blue.svg" alt="a">
            </div>
          </div>
          <div class="header-top--middle f-cont f-16 f-bold">Karyawan</div>
          <div class="header-top--right">
            <div class="header-item" v-if="validateAccess('listEmployees.read') || validateAccess('attendance.read')" @click="showSearch">
              <img src="../../assets/icons/search.svg" alt="">
            </div>
          </div>
        </div>
        <div class="nav w-limit header-tab" id="nav-tab" role="tablist">
          <div class="header-tab--item" id="nav-Karyawan-tab" :data-toggle="validateAccess('employees.listEmployees') && 'tab'" href="#tab-karyawan"
               role="tab" aria-controls="nav-home" aria-selected="true"
               @click="validateAccess('employees.listEmployees') && changeStatusTabsKaryawan()">
            Karyawan
          </div>
          <div class="header-tab--item" id="nav-Absensi-tab" :data-toggle="validateAccess('attendance.read') && 'tab'" href="#tab-absensi"
               role="tab" aria-controls="nav-profile"
               aria-selected="false"
               @click="validateAccess('attendance.read') && changeStatusTabsAbsensi()">Absensi
          </div>
        </div>
      </div>


      <!-- SEARCH PAGE KARYAWAN -->
      <div class="backgroundSearch pageSearchOutlet z-99">
        <div class="d-block" id="list-search-karyawan-scrolled" style="overflow-y: scroll; height: 100vh">
          <div class="d-block" id="list-search-karyawan">
            <div class="header-top bg-white pageSearchOutlet">
              <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left search-wrapper">
                  <input class="search-field" id="input_search_karyawan" type="text" v-on:keyup="inputsearch"
                         v-model="searchKey" placeholder="Cari.." autocomplete="off">
                </div>
                <div class="header-top--right">
                  <div class="header-item" @click="closesearch">
                    <img src="../../assets/img/x2.svg" alt="">
                  </div>
                </div>
              </div>
            </div>

            <div id="loading-bar-spinner" class="spinner">
              <div class="spinner-icon"></div>
            </div>

            <div class="flex-1 main-page">
              <div class="w-limit p-y-16 p-x-20">
                <div class="f-16 f-c-midgrey " id="textSearch"></div>

                <div class="card-item-wrapper m-t-16">

                  <div class="card-item" v-for="dataKaryawan in karyawanSearch" :key="dataKaryawan.idkaryawan">
                    <div @click="godetail(dataKaryawan.idkaryawan)">
                      <div class="top-card">
                        <div class="f-16 f-c-black font-weight-bold" v-html="searchHighlight(dataKaryawan.nama, searchKey)"></div>
                        <div class="card-chevron"></div>
                      </div>
                      <div class="f-14 f-c-midgrey m-t-4" v-if="dataKaryawan.statusOutlet === 'true'"><b>Kasir
                      </b>{{ dataKaryawan.karyawanOutlet }}
                      </div>
                      <div class="f-14 f-c-midgrey m-t-4" v-if="dataKaryawan.statusWorkshop === 'true'"><b>Workshop
                      </b>{{ dataKaryawan.karyawanWorkshop }}
                      </div>
                      <div class="f-14 f-c-midgrey m-t-4" v-if="dataKaryawan.statuskurir === 'true'"><b>Sebagai
                        Kurir</b>
                      </div>
                    </div>

                    <div class="f-12 f-c-muted m-t-4">ID: {{ dataKaryawan.idkaryawan }}</div>
                    <div class="separator-line m-x-min m-t-10"></div>
                    <div class="d-flex">
                      <div class="bottom-card m-t-10 w-100 justify-content-start">
                        <button type="button" class="btn btn-outline-primary f-12" style="padding: 2px 8px"
                                @click="copyToClipboard(dataKaryawan.idkaryawan)">
                          Salin ID <img src="../../assets/icons/copy2.svg" alt="" class="m-l-4" height="12px">
                        </button>
                      </div>
                      <div class="bottom-card m-t-10 w-100 justify-content-end">
                        <div class="badge color-blue"
                             v-if="dataKaryawan.logkasir === 'true' && dataKaryawan.logworkshop==='false'">Sedang Login Kasir
                        </div>
                        <div class="badge color-blue"
                             v-if="dataKaryawan.logworkshop === 'true' && dataKaryawan.logkasir==='false'">Sedang Login
                          Workshop
                        </div>
                        <div class="badge color-blue"
                             v-if="dataKaryawan.logkasir === 'true' && dataKaryawan.logworkshop === 'true'">Sedang Login Kasir
                          &
                          Workshop
                        </div>
                        <div class="badge color-grey"
                             v-if="dataKaryawan.logkasir === 'false' && dataKaryawan.logworkshop === 'false'">Belum Login
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="loadmoreSpinner" id="loadingSpinnerKaryawanSearch" style="display: none">
                    <center>
                      <div class="sp sp-circle"></div>
                    </center>
                  </div>

                </div>

              </div>
            </div>
            <!--            <div class="pointer-with-nav">-->
            <!--                <span><img src="../../assets/img/plus-1.svg" alt="" @click="createstaff"></span>-->
            <!--            </div>-->
          </div>
        </div>
      </div>


      <!-- SEARCH PAGE ABSENSI -->
      <div class="backgroundSearch pageSearchWorkshop z-99">
        <div class="d-block" id="list-search-absensi-scrolled" style="overflow-y: scroll; height: 100vh">
          <div class="d-block" id="list-search-absensi">
            <div class="header-top bg-white pageSearchWorkshop">
              <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left search-wrapper">
                  <input class="search-field" id="input_search_absensi" type="text" v-on:keyup="inputsearchAbsensi"
                         v-model="searchKey" placeholder="Cari.." autocomplete="off">
                </div>
                <div class="header-top--right">
                  <div class="header-item" @click="closesearch">
                    <img src="../../assets/img/x2.svg" alt="">
                  </div>
                </div>
              </div>
            </div>

            <div id="loading-bar-spinner_absensi" class="spinner">
              <div class="spinner-icon"></div>
            </div>

            <div class="flex-1 main-page">
              <div class="w-limit p-y-16 p-x-20">
                <div class="f-16 f-c-midgrey " id="textSearch_Absensi"></div>

                <div class="card-item-wrapper m-t-16">

                  <div class="card-item-wrapper m-t-16" v-for="AbsensiSearch in absensiSearch" :key="AbsensiSearch.id">
                    <div class="card-item" @click="showrekapabsen(AbsensiSearch)">
                      <div class="top-card">
                        <div class="f-16 f-semi" v-html="searchHighlight(AbsensiSearch.nama, searchKey)"></div>
                        <div class="card-chevron"></div>
                      </div>
                      <div class="m-t-4">
                        <div class="f-14 f-c-midgrey" v-if="AbsensiSearch.statusOutlet === 'true'"><b>Kasir
                        </b>{{ AbsensiSearch.karyawanOutlet }}
                        </div>
                        <div class="f-14 f-c-midgrey" v-if="AbsensiSearch.statusWorkshop === 'true'"><b>Workshop
                        </b>{{ AbsensiSearch.karyawanWorkshop }}
                        </div>
                        <div class="f-14 f-c-midgrey" v-if="AbsensiSearch.statuskurir === 'true'"><b>Sebagai
                          Kurir</b></div>
                      </div>
                      <div class="separator-line m-x-min m-t-10"></div>
                      <div class="bottom-card right m-t-10">
                        <div class="badge color-blue f-regular">Masuk <b>{{ AbsensiSearch.absenmasuk }} Hari</b></div>
                        <div class="badge color-blue f-regular">Tidak Masuk <b>{{ AbsensiSearch.absenalpha }} Hari</b></div>
                      </div>
                    </div>

                  </div>
                  <div class="loadmoreSpinner" id="loadingSpinnerAbsensiSearch" style="display: none">
                    <center>
                      <div class="sp sp-circle"></div>
                    </center>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MAIN CONTENT -->
      <main class="main-page-tab has-bottom-menu pageDefault">
        <div class="tab-content" id="nav-tabContent">

          <!--------------------
          ---- TAB KARYAWAN ----
          --------------------->
          <div class="tab-pane fade show active" id="tab-karyawan" role="tabpanel" aria-labelledby="nav-home-tab">
            <div class="">

              <div class="content-wrapper" v-if="karyawan.length===0">
                <!-- IF KARYAWAN EMPTY -->
                <div class="empty-state">
                  <div class="empty-state--icon"></div>
                  <div class="f-16 f-bold">Belum ada karyawan terdaftar</div>
                  <div class="f-14 f-c-midgrey">Klik tombol + untuk menambahkan</div>
                </div>
                <!-- PLUS ICON -->
                <div class="flying-button-wrapper w-limit" v-if="validateAccess('listEmployees.create')">
                  <div class="flying-inside">
                    <div class="flying-button add-karyawan" @click="createstaff"></div>
                  </div>
                </div>
              </div>

              <div class="content-wrapper" v-else>
                <!-- IF KARYAWAN NOT EMPTY -->
                <div class="w-limit p-y-16 p-x-20">
                  <div class="f-16 f-c-midgrey">Total {{ length_data }} Karyawan</div>

                  <!-- FILTER -->
                  <FilterSorting :jenisFilter="'karyawan'" @filter="filter"/>

                  <!--
                  LIST - KARYAWAN
                  Represented by '.card-item'
                  --->
                  <div class="card-item-wrapper m-t-16">

                    <div class="card-item" v-for="K in karyawan" :key="K.idkaryawan">
                      <div class="" @click="godetail(K.idkaryawan)">
                        <div class="d-flex justify-content-between w-100 p-r-16 p-l-16 p-t-8 p-b-8 gap-16">
                          <div class="">
                            <img
                                class="foto"
                                v-bind:src="K.foto"
                                alt="foto"
                                style="width: 50px;height: 50px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;"
                            >
                          </div>
                          <div class="w-100 justify-content-between">
                            <div class="f-16 f-c-black font-weight-bold">{{ K.nama }}</div>
                            <div class="f-14 f-c-midgrey m-t-4" v-if="K.statusOutlet === 'true'"><b>Kasir
                            </b>{{ K.karyawanOutlet }}
                            </div>
                            <div class="f-14 f-c-midgrey m-t-4" v-if="K.statusWorkshop === 'true'"><b>Workshop
                            </b>{{ K.karyawanWorkshop }}
                            </div>
                            <div class="f-14 f-c-midgrey m-t-4" v-if="K.statuskurir === 'true'"><b>Sebagai
                              Kurir</b>
                            </div>
                            <div class="f-12 f-c-muted m-t-4">ID: {{ K.idkaryawan }}</div>
                          </div>
                          <div class="flex-1">
                            <img src="../../assets/icons/chevron_right_4.svg" alt="">
                          </div>

                        </div>
                        <!--                        <div class="top-card">-->
                        <!--                          <div class="f-16 f-c-black font-weight-bold">{{ K.nama }}</div>-->
                        <!--                          <div class="card-chevron"></div>-->
                        <!--                        </div>-->
                        <!--                        <div class="f-14 f-c-midgrey m-t-4" v-if="K.statusOutlet === 'true'"><b>Kasir-->
                        <!--                        </b>{{ K.karyawanOutlet }}-->
                        <!--                        </div>-->
                        <!--                        <div class="f-14 f-c-midgrey m-t-4" v-if="K.statusWorkshop === 'true'"><b>Workshop-->
                        <!--                        </b>{{ K.karyawanWorkshop }}-->
                        <!--                        </div>-->
                        <!--                        <div class="f-14 f-c-midgrey m-t-4" v-if="K.statuskurir === 'true'"><b>Sebagai-->
                        <!--                          Kurir</b>-->
                        <!--                        </div>-->

                        <div class="separator-line m-x-min m-t-10"></div>
                      </div>


                      <div class="d-flex">
                        <div class="bottom-card m-t-10 w-100 justify-content-start">
                          <button type="button" class="btn btn-outline-primary f-12" style="padding: 2px 8px"
                                  @click="copyToClipboard(K.idkaryawan)">
                            Salin ID <img src="../../assets/icons/copy2.svg" alt="" class="m-l-4" height="12px">
                          </button>
                        </div>
                        <div class="bottom-card m-t-10 w-100 justify-content-end">
                          <div class="badge color-blue"
                               v-if="K.logkasir === 'true' && K.logworkshop==='false'">Sedang Login Kasir
                          </div>
                          <div class="badge color-blue"
                               v-if="K.logworkshop === 'true' && K.logkasir==='false'">Sedang Login
                            Workshop
                          </div>
                          <div class="badge color-blue"
                               v-if="K.logkasir === 'true' && K.logworkshop === 'true'">Sedang Login Kasir
                            &
                            Workshop
                          </div>
                          <div class="badge color-grey"
                               v-if="K.logkasir === 'false' && K.logworkshop === 'false'">Belum Login
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="loadmoreSpinner" id="loadingSpinnerKaryawan" style="display: none">
                      <center>
                        <div class="sp sp-circle"></div>
                      </center>
                    </div>

                  </div>

                  <!-- PLUS ICON -->
                  <div class="flying-button-wrapper w-limit" v-if="validateAccess('listEmployees.create')">
                    <div class="flying-inside">
                      <div class="flying-button add-karyawan" @click="createstaff"></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>

          <!-------------------
          ---- TAB ABSENSI ----
          -------------------->
          <div class="tab-pane fade show" id="tab-absensi" role="tabpanel" aria-labelledby="nav-profile-tab">
            <div class="">
              <div class="content-wrapper" v-if="List_Absen_Default.length===0">
                <div class="w-limit p-y-16 p-x-20">
                  <div class="f-16 f-c-blue dropdown-toggle" @click="gosetperiode">{{ format_tanggal_absensi }}</div>
                  <!-- IF ABSENSI EMPTY -->
                  <!--                                <div class="w-limit p-y-16 p-x-20">-->
                  <div class="empty-state" style="padding: 0px 0px">
                    <div class="empty-state--icon"></div>
                    <div class="f-16 f-bold">Belum ada absensi</div>
                    <div class="f-14 f-c-midgrey">Silakan menambah karyawan terlebih dahulu</div>
                  </div>
                  <!--                                </div>-->
                  <!-- PLUS ICON -->
                  <div class="flying-button-wrapper w-limit context-menu" v-if="ekspor.onprogress == 0">
                    <div class="flying-inside dropup">
                      <a class="flying-button" data-toggle="dropdown" data-display="static"></a>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="gotoimpor">
                          <div class="icon-prefix" style="background-image: url('../../assets/icons/upload.svg')">
                          </div>
                          Impor Data Absensi
                        </a>
                        <a class="dropdown-item" @click="exportBackground">
                          <div class="icon-prefix"
                               style="background-image: url('../../assets/icons/upload(1).svg')"></div>
                          Ekspor Data
                          Absensi
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="content-wrapper" v-else>
                <!-- IF ABSENSI NOT EMPTY -->
                <div class="w-limit p-y-16 p-x-20">
                  <div class="d-flex-between-center">
                    <div class="f-16 f-c-blue dropdown-toggle" @click="gosetperiode">{{ format_tanggal_absensi }}</div>
                    <div class="f-16 f-c-blue" style="margin-top: 28px">
                      <FilterSorting :jenisFilter="'absensi'" @filter="filter"/>
                    </div>

                    <!-- FILTER -->
                    <!--                                        <div class="f-16 f-c-blue dropdown-toggle" data-toggle="dropdown"-->
                    <!--                                             id="dropdownfilterabsensi">Filter</div>-->
                    <!--                                        <div class="dropdown-menu dropdown-menu-right mod">-->
                    <!--                                            <div class="dropdown-item plain">Urutkan:</div>-->
                    <!--                                            <a class="dropdown-item" id="az" href="#" v-on:click="sortingabsensidefault('asc')">Urut A-Z</a>-->
                    <!--                                            <a class="dropdown-item" id="za" href="#" v-on:click="sortingabsensidefault('desc')">Urut Z-A</a>-->
                    <!--                                            <a class="dropdown-item" id="baru" href="#" v-on:click="sortingabsensidefault('terbaru')">Urut Terbaru</a>-->
                    <!--                                            <a class="dropdown-item" id="lama" href="#" v-on:click="sortingabsensidefault('terlama')">Urut Terlama</a>-->
                    <!--                                        </div>-->
                  </div>

                  <!--
                  LIST - ABSENSI
                  Represented by '.card-item'
                  --->
                  <div class="card-item-wrapper m-t-16" v-for="Absensi in List_Absen_Default" :key="Absensi.id">
                    <div class="card-item" @click="showrekapabsen(Absensi)">
                      <div class="top-card">
                        <div class="f-16 f-semi">{{ Absensi.nama }}</div>
                        <div class="card-chevron"></div>
                      </div>
                      <div class="m-t-4">
                        <div class="f-14 f-c-midgrey" v-if="Absensi.statusOutlet === 'true'"><b>Kasir
                        </b>{{ Absensi.karyawanOutlet }}
                        </div>
                        <div class="f-14 f-c-midgrey" v-if="Absensi.statusWorkshop === 'true'"><b>Workshop
                        </b>{{ Absensi.karyawanWorkshop }}
                        </div>
                        <div class="f-14 f-c-midgrey" v-if="Absensi.statuskurir === 'true'"><b>Sebagai
                          Kurir</b></div>
                      </div>
                      <div class="separator-line m-x-min m-t-10"></div>
                      <div class="bottom-card right m-t-10">
                        <div class="badge color-blue f-regular">Masuk <b>{{ Absensi.absenmasuk }} Hari</b></div>
                        <div class="badge color-blue f-regular">Tidak Masuk <b>{{ Absensi.absenalpha }} Hari</b></div>
                      </div>
                    </div>

                  </div>
                  <div class="loadmoreSpinner" id="loadingSpinnerAbsensi" style="display: none">
                    <center>
                      <div class="sp sp-circle"></div>
                    </center>
                  </div>
                  <!-- PLUS ICON -->
                  <div class="flying-button-wrapper w-limit context-menu" v-if="ekspor.onprogress == 0">
                    <div class="flying-inside dropup">
                      <a class="flying-button" data-toggle="dropdown" data-display="static"></a>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="gotoimpor">
                          <div class="icon-prefix" style="background-image: url('../../assets/icons/upload.svg')">
                          </div>
                          Impor Data Absensi
                        </a>
                        <a class="dropdown-item" @click="exportBackground">
                          <div class="icon-prefix"
                               style="background-image: url('../../assets/icons/upload(1).svg')"></div>
                          Ekspor Data
                          Absensi
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </main>
      <div class="modal fade" id="modal-lewati-panduan-karyawan" role="dialog">
        <div class="modal-dialog modal-lg  bani-modal">
          <div class="modal-content w-limit">
            <div class="modal-header">
              <div class="nav-btn kiri"></div>
              <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
              <div class="nav-btn kanan tutup">
              </div>
            </div>
            <div class="modal-body">
              <p>Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                panduan. Apakah Anda yakin ingin keluar dari panduan?</p>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary btn-long m-d-20"
                      @click="onboardingKaryawan"
                      data-dismiss="modal">
                Lanjutkan Panduan
              </button>
              <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar
                Dari
                Mode Panduan</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalNullData" role="dialog">
      <div class="modal-dialog modal-lg  bani-modal">
        <div class="modal-content w-limit">
          <div class="modal-header">
            <div class="nav-btn kiri"></div>
            <h5 class="navbar-title text-center">Data Tidak Ditemukan</h5>
            <div class="nav-btn kanan tutup">
              <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
            </div>
          </div>
          <div class="modal-body">
            <div class="p-d-12">
              <b>Belum ada</b> data absensi pada periode yang anda tentukan.
              {{ dataTerakhirAbsen }}
            </div>
            <div>
              Yakin tetap ingin menampilkan data pada periode ini?
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-long" data-dismiss="modal"
                    @click="dataAbsensi(true)">Tetap Tampilkan
            </button>
          </div>
        </div>
      </div>
    </div>

    <PeriodeAbsen v-bind:class="{hidesection: !issetPeriode}" v-on:isdetail="islist" ref="setperiode"
                  v-bind:datalistabsen="List_Absen_Default" v-on:back="islistfromclose"
                  @setPeriodeAbsen="setAbsenList"
                  :periode_absen="periode_absen"
    />

    <input type="text" id="idkaryawan" style="opacity: 0">
  </div>

</template>

<script>
import PeriodeAbsen from "./Absensi/PeriodeAbsen";
import FilterSorting from "@/component-items/FilterSorting";

export default {
  name: "KaryawanList",
  computed: {
    https() {
      return https
    }
  },
  components: {PeriodeAbsen, FilterSorting},
  data() {
    return {
      idkaryawan: '',
      karyawan: [],
      name_karyawan: '',
      kasir: '',
      workshop: '',
      isClickedlist: false,
      issetPeriode: false,
      searchKey: "",
      statusTabs: "karyawan",
      karyawanSearch: [],
      absensiSearch: [],
      List_Absen_Default: [],
      length_data: 0,
      limit_data: 20,
      page_number: 1,
      format_tanggal_absensi: '',
      format_tanggal_awal_absensi: '',
      format_tanggal_akhir_absensi: '',
      format_month_absensi: '',
      format_year_absensi: '',
      requestHeaders: {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        }
      },
      bucketUrl: 'https://storage.googleapis.com',
      karyawanPagination: {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
      },
      karyawanSearchPagination: {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
        key: ""
      },
      absensiPagination: {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
        periodeAbsen: {
          filter_by: "",
          start_date: "",
          end_date: "",
          month: "",
          year: "",
        }
      },
      absensiSearchPagination: {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
        key: ""
      },

      dataExist: false,
      periodeCalled: false,
      dataTerakhirAbsen: "",

      ekspor: {
        onprogress: 0,
        progress_looping: 0,
        lenght: 0,
        exportlink: "",
        timer: null
      }
    }
  },
  props: ["datakaryawanlist", "datarekap", "periode_absen"],
  mounted() {
    $('#close').hide();
    $('#loadingPage').show()
    $('#loadingPage').addClass('overlayLoading')
    $(".pageSearchOutlet").prop("style", "display:none");
    $(".pageSearchWorkshop").prop("style", "display:none");
    if (this.validateAccess('attendance.read') && !this.validateAccess('employees.listEmployees')) {
      $('#nav-Absensi-tab').click();
      return
    }
    if (this.$router.history.current.hash === '#absensi') {
      $('#nav-Absensi-tab').click();
    } else if (this.$router.history.current.hash === '#karyawan' || this.$router.history.current.hash === '') {
      $('#nav-Karyawan-tab').click();
    }

    this.scroll();
  },
  methods: {
    copyToClipboard(idkaryawan) {
      $("#idkaryawan").val(idkaryawan);
      var copyText = document.getElementById("idkaryawan");
      copyText.select();
      copyText.setSelectionRange(0, 99999)
      document.execCommand("copy");

      this.$toast.success("ID karyawan tersailn")
    },

    scroll() {
      window.onscroll = () => {
        if ($('#loadingSpinnerKaryawan').is(":hidden")) {
          if ($("#tab-karyawan").is(":visible")) {
            if (this.karyawanPagination.pageNumber <= Math.ceil(this.karyawanPagination.length / this.karyawanPagination.limit)) {
              if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                this.karyawanPagination.offset = (this.karyawanPagination.pageNumber * this.karyawanPagination.limit);
                this.getlistkaryawan();
                $('#loadingSpinnerKaryawan').show()
              }
            }
          }
        }

        // if ($('#loadingSpinnerKaryawanSearch').is(":hidden")) {
        //     if ($(".pageSearchOutlet").is(":visible")) {
        //         if (this.karyawanSearchPagination.pageNumber <= Math.ceil(this.karyawanSearchPagination.length / this.karyawanSearchPagination.limit)) {
        // 	        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
        // 		        this.karyawanSearchPagination.offset = (this.karyawanSearchPagination.pageNumber * this.karyawanSearchPagination.limit);
        // 		        this.searchData()
        // 		        $('#loadingSpinnerKaryawanSearch').show()
        // 	        }
        //         }
        //     }
        // }

        if ($('#loadingSpinnerAbsensi').is(":hidden")) {
          if ($("#tab-absensi").is(":visible")) {
            if (this.absensiPagination.pageNumber <= Math.ceil(this.absensiPagination.length / this.absensiPagination.limit)) {
              if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                this.absensiPagination.offset = (this.absensiPagination.pageNumber * this.absensiPagination.limit);
                this.absenList();
                $('#loadingSpinnerAbsensi').show()
              }
            }
          }
        }

        // if ($('#loadingSpinnerAbsensiSearch').is(":hidden")) {
        //     if ($(".pageSearchWorkshop").is(":visible")) {
        //         if (this.absensiSearchPagination.pageNumber <= Math.ceil(this.absensiSearchPagination.length / this.absensiSearchPagination.limit)) {
        // 	        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
        // 		        this.absensiSearchPagination.offset = (this.absensiSearchPagination.pageNumber * this.absensiSearchPagination.limit);
        // 		        this.searchData()
        // 		        $('#loadingSpinnerAbsensiSearch').show()
        // 	        }
        //         }
        //     }
        // }
      }

      $("#list-search-karyawan-scrolled").scroll(() => {
        if ($(".pageSearchOutlet").is(":visible")) {
          if (this.karyawanSearchPagination.pageNumber <= Math.ceil(this.karyawanSearchPagination.length / this.karyawanSearchPagination.limit)) {
            if (Math.floor($("#list-search-karyawan-scrolled").scrollTop()) > 0 && Math.floor($("#list-search-karyawan-scrolled").scrollTop()) >= Math.floor($("#list-search-karyawan").height()) - $(document).height() - 100) {
              this.karyawanSearchPagination.offset = (this.karyawanSearchPagination.pageNumber * this.karyawanSearchPagination.limit);
              this.searchData()
              $('#loadingSpinnerKaryawanSearch').show()
            }
          }
        }
      })

      $("#list-search-absensi-scrolled").scroll(() => {
        if ($(".pageSearchWorkshop").is(":visible")) {
          if (this.absensiSearchPagination.pageNumber <= Math.ceil(this.absensiSearchPagination.length / this.absensiSearchPagination.limit)) {
            if (Math.floor($("#list-search-absensi-scrolled").scrollTop()) > 0 && Math.floor($("#list-search-absensi-scrolled").scrollTop()) >= Math.floor($("#list-search-absensi").height()) - $(document).height() - 100) {
              this.absensiSearchPagination.offset = (this.absensiSearchPagination.pageNumber * this.absensiSearchPagination.limit);
              this.searchData()
              $('#loadingSpinnerAbsensiSearch').show()
            }
          }
        }
      })
    },
    cekOnboardingKaryawan() {
      if (localStorage.getItem("step_walkthrough") !== null && localStorage.getItem("step_walkthrough") !== undefined && localStorage.getItem("step_walkthrough") == '2') {
        this.onboardingKaryawan()
      }
    },
    onboardingKaryawan() {
      const tourKaryawan = new Shepherd.Tour({
        defaultStepOptions: {
          scrollTo: {
            behavior: 'smooth',
            block: 'center'
          },
          beforeShowPromise: function () {
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve();
              }, 100)
            });
          }
        },
        useModalOverlay: true,
      });

      tourKaryawan.addSteps([
        {
          classes: '',
          title: 'Tambah Data Karyawan',
          text: '<p>Buat <b>data sekaligus akun karyawan</b> yang akan digunakan di aplikasi <b>kasir atau produksi</b></p>',
          attachTo: {
            element: '.flying-button',
            on: 'top'
          },
          advanceOn: {
            selector: '.flying-button',
            event: 'click'
          },
          buttons: [{
            classes: "shp-btn-left show-modal-lewati-karyawan",
            secondary: true,
            text: 'Lewati',
          }],
        },
      ]);

      setTimeout(() => {
        $(".add-karyawan").addClass("animated pulse infinite")
        $(".show-modal-lewati-karyawan").click(function () {
          tourKaryawan.cancel()
          $("#modal-lewati-panduan-karyawan").modal({backdrop: 'static', keyboard: false})
        })

      }, 1500)
      tourKaryawan.start()
    },

    async apiAbsenList() {
      var res;
      try {
        switch (this.absensiPagination.periodeAbsen.filter_by) {
          case "periode":
            res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_with_range_date'
                + '?tanggal_mulai=' + this.absensiPagination.periodeAbsen.start_date
                + '&tanggal_selesai=' + this.absensiPagination.periodeAbsen.end_date
                + '&offset=' + this.absensiPagination.offset
                + '&limit=' + this.absensiPagination.limit
                + '&order_by=' + this.absensiPagination.orderBy
                + '&sort_by=' + this.absensiPagination.sortBy
                , this.requestHeaders);
            break;
          case "month":
            res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_by_month'
                + '?bulan=' + this.absensiPagination.periodeAbsen.month
                + '&offset=' + this.absensiPagination.offset
                + '&limit=' + this.absensiPagination.limit
                + '&order_by=' + this.absensiPagination.orderBy
                + '&sort_by=' + this.absensiPagination.sortBy
                , this.requestHeaders);
            break;
          case "year":
            res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_by_year'
                + '?tahun=' + this.absensiPagination.periodeAbsen.year
                + '&offset=' + this.absensiPagination.offset
                + '&limit=' + this.absensiPagination.limit
                + '&order_by=' + this.absensiPagination.orderBy
                + '&sort_by=' + this.absensiPagination.sortBy
                , this.requestHeaders);
            break;
          default:
            res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_karyawan_default'
                + '?sort_by=' + this.absensiPagination.sortBy
                + '&order_by=' + this.absensiPagination.orderBy
                + '&limit=' + this.absensiPagination.limit
                + '&offset=' + this.absensiPagination.offset,
                this.requestHeaders)
            break;
        }

        return res;
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingSpinnerAbsensi').hide()
        $('#loadingPage').hide();
        $('#loadingPage').removeClass('overlayLoading');
      }
    },
    async absenList(refresh = false) {
      $('#listkaryawan_Absensi').show();
      this.issetPeriode = false;

      if (refresh) {
        this.absensiPagination.limit = 20
        this.absensiPagination.offset = 0
        this.absensiPagination.length = 0
        this.absensiPagination.pageNumber = 0
        this.absensiPagination.sortBy = "nama"
        this.absensiPagination.orderBy = "ASC"
        this.absensiPagination.periodeAbsen = this.periode_absen

        this.List_Absen_Default = []
      }

      if (this.absensiPagination.offset === 0) {
        $('#loadingSpinnerAbsensi').show()
        $('#loadingPage').show();
        $('#loadingPage').addClass('overlayLoading');
      }

      try {
        var res = await this.apiAbsenList()

        if (res.status === 200) {
          this.dataExist = res.data.periode.data_exist
          this.dataTerakhirAbsen = res.data.periode.data_terakhir_absen
          this.dataAbsensi(this.dataExist)
          $('#loadingPage').hide();
          $('#loadingPage').removeClass('overlayLoading');

          var list = res.data.data;
          this.absensiPagination.length += list.length
          var periode = res.data.periode;
          this.format_tanggal_absensi = periode.tanggal_formated_string;
          for (var i = 0; i < list.length; i++) {
            var kurirAbsensi = "false";
            var statuskurirAbsensi = "false";
            var WorkshopAbsensi = "false";
            var statusWorkshopAbsensi = "false";
            var OutletAbsensi = "false";
            var statusOutletAbsensi = "false";

            if (list[i].status_kurir === 1) {
              statuskurirAbsensi = "true";
              kurirAbsensi = "true";
            }

            if (list[i].status_outlet === 1) {
              statusOutletAbsensi = "true";
              OutletAbsensi = "true";
            }

            if (list[i].status_workshop === 1) {
              statusWorkshopAbsensi = "true";
              WorkshopAbsensi = "true";
            }


            this.List_Absen_Default.push({
              id: list[i].idkaryawan,
              nama: list[i].nama,
              statusWorkshop: statusWorkshopAbsensi,
              statusOutlet: statusOutletAbsensi,
              karyawanWorkshop: list[i].workshop,
              karyawanOutlet: list[i].outlet,
              statuskurir: statuskurirAbsensi,
              absenmasuk: list[i].absen_masuk,
              absenalpha: list[i].absen_tidak_masuk,
              filterby: periode.periode,
              valuemonth: periode.periode_value_1,
              valueawal: periode.periode_value_1,
              valueakhir: periode.periode_value_2,
            })
          }
          this.absensiPagination.pageNumber++
          $('#loadingSpinnerAbsensi').hide()
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingSpinnerAbsensi').hide()
        $('#loadingPage').hide();
        $('#loadingPage').removeClass('overlayLoading');
      }
    },
    setAbsenList(periode_absen) {
      this.absensiPagination = {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "created_at",
        orderBy: "DESC",
        periodeAbsen: periode_absen
      }
      this.absenList(true)
    },
    async skipOnboarding(params) {
      $("#modal-lewati-panduan-karyawan").modal("hide")
      $(".add-karyawan").removeClass("animated pulse infinite")
      try {
        const datawalkthrough = new FormData
        datawalkthrough.append('walkthrough', params)
        const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
          }
        });
        if (response.data.code === 200) {
          if (response.data.status === true) {
            localStorage.setItem("step_walkthrough", params)

          }
        } else {
          this.popupType = "error";
          this.popupMessage = response.data.msg;
        }
      } catch (e) {
        if (!e.code) {
          this.popupType = "error";
          this.popupErrorException = e;
        }
      }
    },
    islistfromclose() {
      $('#listkaryawan_Absensi').show();
      this.issetPeriode = false;
      this.periodeCalled = false;
      $('#nav-Absensi-tab').click();
    },

    islist(respon) {
      this.List_Absen_Default = [];
      $('#listkaryawan_Absensi').show();
      this.issetPeriode = false;
      $('#nav-Absensi-tab').click();
      var newrespon = respon.data;
      var periode = respon.periode;
      this.format_tanggal_absensi = periode.tanggal_formated_string;
      for (var i = 0; i < newrespon.length; i++) {
        var kurirAbsensi = "false";
        var statuskurirAbsensi = "false";
        var WorkshopAbsensi = "false";
        var statusWorkshopAbsensi = "false";
        var OutletAbsensi = "false";
        var statusOutletAbsensi = "false";
        if (newrespon[i].status_kurir === 1) {
          statuskurirAbsensi = "true";
          kurirAbsensi = "true";
        }
        if (newrespon[i].status_outlet === 1) {
          statusOutletAbsensi = "true";
          OutletAbsensi = "true";
        }
        if (newrespon[i].status_workshop === 1) {
          statusWorkshopAbsensi = "true";
          WorkshopAbsensi = "true";
        }
        this.List_Absen_Default.push({
          id: newrespon[i].idkaryawan,
          nama: newrespon[i].nama,
          statusWorkshop: statusWorkshopAbsensi,
          statusOutlet: statusOutletAbsensi,
          karyawanWorkshop: newrespon[i].workshop,
          karyawanOutlet: newrespon[i].outlet,
          statuskurir: statuskurirAbsensi,
          absenmasuk: newrespon[i].absen_masuk,
          absenalpha: newrespon[i].absen_tidak_masuk,
          filterby: periode.periode,
          valuemonth: periode.periode_value_1,
          valueawal: periode.periode_value_1,
          valueakhir: periode.periode_value_2,
        })
      }
    },

    gosetperiode() {
      this.issetPeriode = true;
      this.periodeCalled = true;
      $('#listkaryawan_Absensi').hide();
    },

    scrollLoader() {
      window.onscroll = () => {
        //sleep(2000);
        // cek tidak sedang loading
        if ($('#loadingPage').is(":hidden")) {
          // cek sedang di tab karyawan
          if ($("#nav-Karyawan-tab").is(":visible")) {
            // cek masih ada halaman yng perlu di load
            if (this.page_number <= Math.ceil(this.length_data / this.limit_data)) {
              // cek sudah bawah sendiri
              if (Math.floor($(window).scrollTop()) === Math.floor($(document).height() - $(window).height())) {
                this.getlistkaryawan();
              }
            }
          } else if ($("#nav-Absensi-tab").is(":visible")) {
            // cek masih ada halaman yng perlu di load
            if (this.page_number <= Math.ceil(this.length_data / this.limit_data)) {
              // cek sudah bawah sendiri
              if (Math.floor($(window).scrollTop()) === Math.floor($(document).height() - $(window).height())) {
                this.GetListAbsenDefault();
              }
            }
          }
        }

      };
    },

    back() {
      if (this.ekspor.onprogress === 1) {
        return
      }
      this.$router.push('/dashboard')
    },

    dashboard() {
      this.$router.push('/dashboard')
    },

    penggajian() {
      this.$router.push('/addpenggajian')
    },

    outlet() {
      this.$router.push('/addoutlet')
    },

    menu() {
      this.$router.push('/detailakunowner')
    },

    toggleMenu() {
      $("#nav-bottom").toggleClass("is-open");
    },

    godetail(idkaryawan) {
      this.smartTrackingClick("detail_karyawan");

      this.$emit("showdetail", idkaryawan)

    },

    createstaff() {
      this.$emit("showcreatestaff")
    },

    gotoimpor() {
      this.$emit("showimporabsen")
    },

            showrekapabsen(dataAbsensi){
				this.$emit('showrekapabsen',{
					idkaryawan: dataAbsensi.id,
					filterby:dataAbsensi.filterby,
					valueyear: dataAbsensi.filterby == "by_tahun" ? dataAbsensi.valueawal : undefined,
					valuemonth:dataAbsensi.valuemonth,
					valueawal: dataAbsensi.valueawal,
					valueakhir:dataAbsensi.valueakhir
				})
            },

    changeStatusTabsKaryawan() {
      this.smartTrackingClick("list_karyawan");
      this.statusTabs = "karyawan";
      $('#nav-Karyawan-tab').click();
      this.page_number = 1;
      this.getlistkaryawan();
    },

    changeStatusTabsAbsensi() {
      this.smartTrackingClick("list_absensi");
      this.scrolltop()
      this.statusTabs = "absensi";
      $('#nav-Absensi-tab').click();
      // this.GetListAbsenDefault();
      this.absenList(true)
    },

    scrolltop() {
      $(window).scrollTop(0)
    },

    closesearch() {
      $(".pageSearchWorkshop").hide();
      $(".pageSearchOutlet").hide();
      $(".pageDefault").show();
      $("#textSearch").text("");
      $("#textSearch_Absensi").text("");
      this.karyawanSearch = [];
      this.absensiSearch = "";
      this.searchKey = "";

      this.karyawanSearchPagination = {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
        key: ""
      }
      this.absensiSearchPagination = {
        limit: 20,
        offset: 0,
        length: 0,
        pageNumber: 0,
        sortBy: "nama",
        orderBy: "ASC",
        key: ""
      }
    },

    showSearch() {
      $(".showPageSearch").addClass("animated slideInDown")
      $(".spinner").prop("style", "display:none");
      $("#textSearch").text("Ketik minimal 2 karakter")
      $("#textSearch_Absensi").text("Ketik minimal 2 karakter")
      $(".pageDefault").hide();
      if (this.statusTabs === 'karyawan') {
        $(".pageSearchOutlet").show();
      } else {
        $(".pageSearchWorkshop").show();
      }
      $("#input_search_karyawan").focus();
      $("#input_search_absensi").focus();
    },

    inputsearch(event) {
      var name = event.target.value;
      var input = name.replace(/[^0-9A-Za-z_.,' -]+/, '');
      this.searchKey = input;
      this.searchData()
    },

    searchData() {
      $("#textSearch").text("Minimal 2 karakter")
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        $(".spinner").prop("style", "display:inline-block");
        if (this.statusTabs == "karyawan") {
          this.searchOutletFunc();
        } else {
          this.searchAbsenisFunc();
        }
      }, 500);
    },

    async searchOutletFunc() {
      var key = this.searchKey;
      if (this.karyawanSearchPagination.offset === 0 || this.karyawanSearchPagination.key !== key) {
        $("#textSearch").text("Sedang mencari...")
        this.karyawanSearch = []
        this.karyawanSearchPagination = {
          limit: 20,
          offset: 0,
          length: 0,
          pageNumber: 0,
          sortBy: "nama",
          orderBy: "ASC",
          key: key
        }
      }
      if (key.length >= 2) {
        try {
          var idowner = localStorage.getItem('idowner');
          const response = await this.$axios.get(this.$baseurl +
              '/masterData/meta/list_karyawan_meta?idowner=' + idowner + '&key=' + key +
              '&limit=' + this.karyawanSearchPagination.limit + '&offset=' + this.karyawanSearchPagination.offset, this
              .datakaryawanlist.requestHeaders)
          if (response.status === 200) {
            if (response.data.status === true) {
              this.karyawanSearchPagination.length += response.data.data.length
              $("#textSearch").text("Ditemukan " + response.data.lenght_data +
                  " Karyawan dengan kata '" + key + "'")
              if (response.data.data.length > 0) {
                this.karyawanSearch = []
                var data = response.data.data;
                for (var i = 0; i < data.length; i++) {
                  var dataLogToken = data[i].log_token;
                  var statusKaryawanLogKasir = "false";
                  var statusKaryawanLogWorkshop = "false";
                  for (var x = 0; x < dataLogToken.length; x++) {
                    if (dataLogToken[x].idaplikasi === 1) {
                      if (dataLogToken[x].valid === 1) {
                        statusKaryawanLogKasir = "true"
                      }
                    }
                    if (dataLogToken[x].idaplikasi === 2) {
                      if (dataLogToken[x].valid === 1) {
                        statusKaryawanLogWorkshop = "true"
                      }
                    }
                  }

                  var namaOutlet = "";
                  var namaWorkshop = "";
                  var statusOutlet = "false";
                  var statusWorkshop = "false";
                  var workshop = "false";
                  var kasir = "false";
                  var kurir = "false";
                  var statuskurir = "false";
                  if (data[i].daftar_karyawan_outlet != null) {
                    namaOutlet = data[i].daftar_karyawan_outlet.outlet.nama;
                    statusOutlet = "true";
                    kasir = "true";

                  }
                  if (data[i].daftar_karyawan_workshop != null) {
                    namaWorkshop = data[i].daftar_karyawan_workshop.workshop.nama;
                    statusWorkshop = "true";
                    workshop = "true";
                  }
                  if (data[i].daftar_karyawan_kurir != null) {
                    statuskurir = "true";
                    kurir = "true";
                  }
                  this.karyawanSearch.push({
                    idkaryawan: data[i].idkaryawan,
                    nama: data[i].nama,
                    statusWorkshop: statusWorkshop,
                    statusOutlet: statusOutlet,
                    karyawanWorkshop: namaWorkshop,
                    karyawanOutlet: namaOutlet,
                    loginkasir: kasir,
                    loginworkshop: workshop,
                    logkasir: statusKaryawanLogKasir,
                    logworkshop: statusKaryawanLogWorkshop,
                    statuskurir: statuskurir,
                  })
                }
                $('#loadingPage').removeClass('overlayLoading');
                $('#loadingPage').hide()
              } else {
                if (this.karyawanSearchPagination.length === 0) {
                  $("#textSearch").text("Tidak menemukan '" + key + "'");
                }
              }
              this.karyawanSearchPagination.pageNumber++
              $(".spinner").prop("style", "display:none");
            } else {
              this.$toast.error(response.data.msg)
            }
          }
          $('#loadingSpinnerKaryawanSearch').hide()
        } catch (e) {
          this.$catch_error_response(e)
          $('#loadingSpinnerKaryawanSearch').hide()
          $(".spinner").prop("style", "display:none");
        }
      } else {
        this.karyawanSearch = [];
        $(".spinner").prop("style", "display:none");
        $("#textSearch").text("Minimal 2 karakter")
      }
    },

    async getlistkaryawan(refresh = false) {
      if (!this.validateAccess('listEmployees.read')) return
      if (this.karyawanPagination.offset === 0 || refresh) {
        this.karyawanPagination.offset = 0
        this.karyawan = [];
        $('#loadingPage').show()
        $('#loadingPage').addClass('overlayLoading');
      }
      var sort_get;
      var order_get;
      try {
        sort_get = this.karyawanPagination.sortBy;
        order_get = this.karyawanPagination.orderBy;
        var idowner = localStorage.getItem('idowner');
        var limit = this.karyawanPagination.limit;
        var offset = this.karyawanPagination.offset;
        const response = await this.$axios.get(this.$baseurl +
            '/masterData/meta/list_karyawan_meta?idowner=' + idowner + '&sort_by=' + sort_get +
            '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this
            .datakaryawanlist.requestHeaders)
        $('#loadingPage').removeClass('overlayLoading');
        if (response.status === 200) {
          $('#loadingPage').removeClass('overlayLoading');
          if (response.data.status === true) {
            var data = response.data.data;
            this.karyawanPagination.length += data.length
            this.length_data = response.data.lenght_data;
            for (var i = 0; i < data.length; i++) {
              var dataLogToken = data[i].log_token;
              var statusKaryawanLogKasir = "false";
              var statusKaryawanLogWorkshop = "false";
              for (var x = 0; x < dataLogToken.length; x++) {
                if (dataLogToken[x].idaplikasi === 1) {
                  if (dataLogToken[x].valid === 1) {
                    statusKaryawanLogKasir = "true"
                  }
                }
                if (dataLogToken[x].idaplikasi === 2) {
                  if (dataLogToken[x].valid === 1) {
                    statusKaryawanLogWorkshop = "true"
                  }
                }
              }

              var namaOutlet = "";
              var namaWorkshop = "";
              var statusOutlet = "false";
              var statusWorkshop = "false";
              var workshop = "false";
              var kasir = "false";
              var kurir = "false";
              var statuskurir = "false";
              var foto = "";
              if (data[i].daftar_karyawan_outlet != null) {
                namaOutlet = data[i].daftar_karyawan_outlet.outlet.nama;
                statusOutlet = "true";
                kasir = "true";

              }
              if (data[i].daftar_karyawan_workshop != null) {
                namaWorkshop = data[i].daftar_karyawan_workshop.workshop.nama;
                statusWorkshop = "true";
                workshop = "true";
              }
              if (data[i].daftar_karyawan_kurir != null) {
                statuskurir = "true";
                kurir = "true";
              }
              if (data[i].transaksi_foto != null) {
                const e = data[i].transaksi_foto;
                foto = `${this.bucketUrl}/${e['cloud_bucket']}/${e['cloud_name']}`;
              } else {
                foto = '../../assets/gambar/Rectangle43.svg'
              }

              this.karyawan.push({
                idkaryawan: data[i].idkaryawan,
                nama: data[i].nama,
                statusWorkshop: statusWorkshop,
                statusOutlet: statusOutlet,
                karyawanWorkshop: namaWorkshop,
                karyawanOutlet: namaOutlet,
                loginkasir: kasir,
                loginworkshop: workshop,
                logkasir: statusKaryawanLogKasir,
                logworkshop: statusKaryawanLogWorkshop,
                statuskurir: statuskurir,
                foto: foto
              });
            }

            $('#loadingPage').removeClass('overlayLoading');
            $('#loadingPage').hide()

            this.karyawanPagination.pageNumber++
            $('#loadingSpinnerKaryawan').hide()
            this.cekOnboardingKaryawan()
          }
        }

      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingSpinnerKaryawan').hide()
        $('#loadingPage').removeClass('overlayLoading');
        $('#loadingPage').hide()
      }
    },

    async sortingEpayment(key) {
      $("#cardWorkshop").hide();
      $("#spinnerWorkshop").prop("style", "display:inline-block");
      switch (key) {
        case "asc":
          $('#dropdownMenuButton2').text("Urut Dari A - Z ")
          this.getsortingEpayment(1)
          break;
        case "desc":
          $('#dropdownMenuButton2').text("Urut Dari Z - A ")
          this.getsortingEpayment(2)
          break;
        case "terbaru":
          $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
          this.getsortingEpayment(3)
          break;
        case "terlama":
          $('#dropdownMenuButton2').text("Urut Dari Terlama ")
          this.getsortingEpayment(4)
          break;
        default:
          $('#dropdownMenuButton2').text("Filter ")
      }
    },
    async getsortingEpayment(datasortingkaryawan) {
      var sort_by
      var order_by
      // this.isClicked = true
      $('#loadingPage').addClass('overlayLoading');
      $('#loadingPage').show()
      try {
        var idowner = localStorage.getItem('idowner');
        if (datasortingkaryawan === 1) {
          sort_by = "nama";
          order_by = "ASC";
        } else if (datasortingkaryawan === 2) {
          sort_by = "nama";
          order_by = "DESC";
        } else if (datasortingkaryawan === 3) {
          sort_by = "created_at";
          order_by = "DESC";
        } else if (datasortingkaryawan === 4) {
          sort_by = "created_at";
          order_by = "ASC";
        } else {
          return
        }
        const response = await this.$axios.get(this.$baseurl +
            '/masterData/meta/list_karyawan_meta?idowner=' + idowner + '&order_by=' + order_by +
            '&sort_by=' + sort_by, this.requestHeaders)
        if (response.status === 200) {
          if (response.data.status === true) {
            this.karyawan = [];
            var data = response.data.data;
            for (var i = 0; i < data.length; i++) {
              var dataLogToken = data[i].log_token;
              var statusKaryawanLogKasir = "false";
              var statusKaryawanLogWorkshop = "false";
              for (var x = 0; x < dataLogToken.length; x++) {
                if (dataLogToken[x].idaplikasi === 1) {
                  if (dataLogToken[x].valid === 1) {
                    statusKaryawanLogKasir = "true"
                  }
                }
                if (dataLogToken[x].idaplikasi === 2) {
                  if (dataLogToken[x].valid === 1) {
                    statusKaryawanLogWorkshop = "true"
                  }
                }
              }

              var namaOutlet = "";
              var namaWorkshop = "";
              var statusOutlet = "false";
              var statusWorkshop = "false";
              var workshop = "false";
              var kasir = "false";
              var kurir = "false";
              var statuskurir = "false";
              if (data[i].daftar_karyawan_outlet != null) {
                namaOutlet = data[i].daftar_karyawan_outlet.outlet.nama;
                statusOutlet = "true";
                kasir = "true";

              }
              if (data[i].daftar_karyawan_workshop != null) {
                namaWorkshop = data[i].daftar_karyawan_workshop.workshop.nama;
                statusWorkshop = "true";
                workshop = "true";
              }
              if (data[i].daftar_karyawan_kurir != null) {
                statuskurir = "true";
                kurir = "true";
              }
              this.karyawan.push({
                idkaryawan: data[i].idkaryawan,
                nama: data[i].nama,
                statusWorkshop: statusWorkshop,
                statusOutlet: statusOutlet,
                karyawanWorkshop: namaWorkshop,
                karyawanOutlet: namaOutlet,
                loginkasir: kasir,
                loginworkshop: workshop,
                logkasir: statusKaryawanLogKasir,
                logworkshop: statusKaryawanLogWorkshop,
                statuskurir: statuskurir,
              })
            }
            $('#loadingPage').removeClass('overlayLoading');
            $('#loadingPage').hide()
            // this.isClicked = false;
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        this.isClicked = false
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    // <!-- FUNGSI GET LIST ABSEN DEFAULT -->
    async GetListAbsenDefault() {
      if (!this.validateAccess('attendance.read')) return
      if (this.absensiPagination.offset === 0) {
        this.absensiPagination.offset = 0
        $('#loadingPage').show();
        $('#loadingPage').addClass('overlayLoading');
        this.List_Absen_Default = [];
      }
      try {
        const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_karyawan_default'
            + '?sort_by=' + this.absensiPagination.sortBy + '&order_by=' + this.absensiPagination.orderBy +
            '&limit=' + this.absensiPagination.limit + '&offset=' + this.absensiPagination.offset,
            this.requestHeaders);
        if (res.status === 200) {
          $('#loadingPage').hide();
          $('#loadingPage').removeClass('overlayLoading');
          var rawworkshop = res.data.data;
          this.absensiPagination.length = rawworkshop.length
          var periode = res.data.periode;
          this.format_tanggal_absensi = periode.tanggal_formated_string;
          for (var i = 0; i < this.absensiPagination.length; i++) {
            var kurirAbsensi = "false";
            var statuskurirAbsensi = "false";
            var WorkshopAbsensi = "false";
            var statusWorkshopAbsensi = "false";
            var OutletAbsensi = "false";
            var statusOutletAbsensi = "false";

            if (rawworkshop[i].status_kurir === 1) {
              statuskurirAbsensi = "true";
              kurirAbsensi = "true";
            }

            if (rawworkshop[i].status_outlet === 1) {
              statusOutletAbsensi = "true";
              OutletAbsensi = "true";
            }

            if (rawworkshop[i].status_workshop === 1) {
              statusWorkshopAbsensi = "true";
              WorkshopAbsensi = "true";
            }


            this.List_Absen_Default.push({
              id: rawworkshop[i].idkaryawan,
              nama: rawworkshop[i].nama,
              statusWorkshop: statusWorkshopAbsensi,
              statusOutlet: statusOutletAbsensi,
              karyawanWorkshop: rawworkshop[i].workshop,
              karyawanOutlet: rawworkshop[i].outlet,
              statuskurir: statuskurirAbsensi,
              absenmasuk: rawworkshop[i].absen_masuk,
              absenalpha: rawworkshop[i].absen_tidak_masuk,
              filterby: periode.periode,
              valuemonth: periode.periode_value_1,
              valueakhir: periode.periode_value_2,
            })
          }

          if (this.absensiPagination.length > 0) {
            this.absensiPagination.pageNumber++
          }
          $('#loadingSpinnerAbsensi').hide()
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingSpinnerAbsensi').hide()
        $('#loadingPage').hide();
        $('#loadingPage').removeClass('overlayLoading');
      }
    },

    // <!-- FUNGSI GET LIST SORTING ABSEN DEFAULT -->
    async sortingabsensidefault(key) {
      $("#cardWorkshop").hide();
      $("#spinnerWorkshop").prop("style", "display:inline-block");
      switch (key) {
        case "asc":
          $('#dropdownfilterabsensi').text("Urut Dari A - Z ");
          $('#az').addClass('active')
          $('#za').removeClass('active')
          $('#baru').removeClass('active')
          $('#lama').removeClass('active')
          this.getsortingabsensidefault(1);
          break;
        case "desc":
          $('#dropdownfilterabsensi').text("Urut Dari Z - A ");
          $('#za').addClass('active');
          $('#baru').removeClass('active');
          $('#az').removeClass('active');
          $('#lama').removeClass('active');
          this.getsortingabsensidefault(2)
          break;
        case "terbaru":
          $('#dropdownfilterabsensi').text("Urut Dari Terbaru ")
          $('#baru').addClass('active');
          $('#az').removeClass('active');
          $('#za').removeClass('active');
          $('#lama').removeClass('active');
          this.getsortingabsensidefault(3)
          break;
        case "terlama":
          $('#dropdownfilterabsensi').text("Urut Dari Terlama ")
          $('#lama').addClass('active');
          $('#baru').removeClass('active');
          $('#az').removeClass('active');
          $('#za').removeClass('active');
          this.getsortingabsensidefault(4)
          break;
        default:
          $('#dropdownfilterabsensi').text("Filter ")
      }
    },
    async getsortingabsensidefault(Absensi) {
      var sort_by;
      var order_by;
      var key;
      var limit = 20;
      var offset = 0;
      key = '';
      //var key = jika ada search nanti dipake
      $('#loadingPage').show();
      $('#loadingPage').addClass('overlayLoading');
      try {
        if (Absensi === 1) {
          sort_by = "karyawan.nama";
          order_by = "ASC";
        } else if (Absensi === 2) {
          sort_by = "karyawan.nama";
          order_by = "DESC";
        } else if (Absensi === 3) {
          sort_by = "absen_log.created_at";
          order_by = "DESC";
        } else if (Absensi === 4) {
          sort_by = "absen_log.created_at";
          order_by = "ASC";
        } else {
          return
        }
        // var idowner = localStorage.getItem('idowner');
        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_abensi_karyawan_default?key=' + key + '&sort_by=' + sort_by + '&order_by=' + order_by + '&limit=' + limit + '&offset=' + offset, this.requestHeaders)
        if (response.status === 200) {
          if (response.status === 200) {
            this.List_Absen_Default = [];
            $('#loadingPage').hide();
            $('#loadingPage').removeClass('overlayLoading');
            var rawworkshop = response.data.data;
            var periode = response.data.periode;
            this.format_tanggal_absensi = periode.tanggal_formated_string;
            for (var i = 0; i < rawworkshop.length; i++) {
              var kurirAbsensi = "false";
              var statuskurirAbsensi = "false";
              var WorkshopAbsensi = "false";
              var statusWorkshopAbsensi = "false";
              var OutletAbsensi = "false";
              var statusOutletAbsensi = "false";

              if (rawworkshop[i].status_kurir === 1) {
                statuskurirAbsensi = "true";
                kurirAbsensi = "true";
              }

              if (rawworkshop[i].status_outlet === 1) {
                statusOutletAbsensi = "true";
                OutletAbsensi = "true";
              }

              if (rawworkshop[i].status_workshop === 1) {
                statusWorkshopAbsensi = "true";
                WorkshopAbsensi = "true";
              }


              this.List_Absen_Default.push({
                id: rawworkshop[i].idkaryawan,
                nama: rawworkshop[i].nama,
                statusWorkshop: statusWorkshopAbsensi,
                statusOutlet: statusOutletAbsensi,
                karyawanWorkshop: rawworkshop[i].workshop,
                karyawanOutlet: rawworkshop[i].outlet,
                statuskurir: statuskurirAbsensi,
                absenmasuk: rawworkshop[i].absen_masuk,
                absenalpha: rawworkshop[i].absen_tidak_masuk,
                formattanggal: rawworkshop[i].tanggal_format
              })
            }
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        $('#loadingPage').hide();
        $('#loadingPage').removeClass('overlayLoading');
      }
    },


    inputsearchAbsensi(event) {
      var name = event.target.value;
      var input = name.replace(/[^0-9A-Za-z_.,' -]+/, '');
      this.searchKey = input;
      this.searchDataAbsensi()
    },

    searchDataAbsensi() {
      $("#textSearch_Absensi").text("Minimal 2 karakter")
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.absensiSearch = "";
        $(".spinner").prop("style", "display:inline-block");
        if (this.statusTabs == "absensi") {
          this.searchAbsenisFunc();
        } else {
          this.searchOutletFunc();

        }
      }, 500);
    },

    async searchAbsenisFunc() {
      var key = this.searchKey;
      if (this.absensiSearchPagination.offset === 0 || this.absensiSearchPagination.key !== key) {
        this.absensiSearch = [];
        $("#textSearch").text("Sedang mencari...")
        this.absensiSearch = []
        this.absensiSearchPagination = {
          limit: 20,
          offset: 0,
          length: 0,
          pageNumber: 0,
          sortBy: "nama",
          orderBy: "ASC",
          key: ""
        }
      }

      if (key.length >= 2) {
        try {
          const response = await this.$axios.get(this.$baseurl +
              '/masterData/meta/list_abensi_karyawan_default?key=' + key +
              '&limit=' + this.absensiSearchPagination.limit + '&offset=' + this.absensiSearchPagination.offset,
              this.requestHeaders)
          if (response.status === 200) {
            if (response.data.status === true) {
              this.absensiSearchPagination.length += response.data.lenght_data
              $("#textSearch_Absensi").text("Ditemukan " + response.data.data.length +
                  " Karyawan dengan kata '" + key + "'")
              if (response.data.data.length > 0) {
                $('#loadingPage').hide();
                $('#loadingPage').removeClass('overlayLoading');
                var rawworkshop = response.data.data;
                var periode = response.data.periode;
                this.format_tanggal_absensi = periode.tanggal_formated_string;
                for (var i = 0; i < rawworkshop.length; i++) {
                  var kurirAbsensi = "false";
                  var statuskurirAbsensi = "false";
                  var WorkshopAbsensi = "false";
                  var statusWorkshopAbsensi = "false";
                  var OutletAbsensi = "false";
                  var statusOutletAbsensi = "false";

                  if (rawworkshop[i].status_kurir === 1) {
                    statuskurirAbsensi = "true";
                    kurirAbsensi = "true";
                  }

                  if (rawworkshop[i].status_outlet === 1) {
                    statusOutletAbsensi = "true";
                    OutletAbsensi = "true";
                  }

                  if (rawworkshop[i].status_workshop === 1) {
                    statusWorkshopAbsensi = "true";
                    WorkshopAbsensi = "true";
                  }


                  this.absensiSearch.push({
                    id: rawworkshop[i].idkaryawan,
                    nama: rawworkshop[i].nama,
                    statusWorkshop: statusWorkshopAbsensi,
                    statusOutlet: statusOutletAbsensi,
                    karyawanWorkshop: rawworkshop[i].workshop,
                    karyawanOutlet: rawworkshop[i].outlet,
                    statuskurir: statuskurirAbsensi,
                    absenmasuk: rawworkshop[i].absen_masuk,
                    absenalpha: rawworkshop[i].absen_tidak_masuk,
                    formattanggal: rawworkshop[i].tanggal_format,
                    filterby: periode.periode,
                    valuemonth: periode.periode_value_1,
                    valueawal: periode.periode_value_1,
                    valueakhir: periode.periode_value_2,
                  })
                }
                $('#loadingPage').removeClass('overlayLoading');
                $('#loadingPage').hide()
              } else {
                if (this.absensiSearchPagination.length === 0) {
                  $("#textSearch_Absensi").text("Tidak menemukan '" + key + "'");
                }
              }
              this.absensiSearchPagination.pageNumber++
              $(".spinner").prop("style", "display:none");
            } else {
              $("#textSearch_Absensi").text("Tidak menemukan '" + key + "'");
            }
          }
          $('#loadingSpinnerAbsensiSearch').hide()
        } catch (e) {
          this.$catch_error_response(e)
          $('#loadingSpinnerAbsensiSearch').hide()
          $(".spinner").prop("style", "display:none");
        }
      } else {
        this.absensiSearch = "";
        $(".spinner").prop("style", "display:none");
        $("#textSearch").text("Minimal 2 karakter")
      }
    },
    filter(payload) {
      if (payload.type === 'karyawan') {
        this.karyawanPagination = payload.data
        this.getlistkaryawan()
      } else if (payload.type === 'absensi') {
        this.absensiPagination.key = payload.data.key
        this.absensiPagination.length = payload.data.length
        this.absensiPagination.limit = payload.data.limit
        this.absensiPagination.offset = payload.data.offset
        this.absensiPagination.orderBy = payload.data.orderBy
        this.absensiPagination.pageNumber = payload.data.pageNumber
        this.absensiPagination.sortBy = payload.data.sortBy

        this.List_Absen_Default = []

        this.absenList()
      }
      setTimeout(() => {
        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
      }, 1000)
    },
    dataAbsensi(ada) {
      if (this.periodeCalled) {
        if (ada) {
          $('#listkaryawan_Absensi').show();
          this.issetPeriode = false;
          $("#modalNullData").modal("hide")

          this.periodeCalled = false;
        } else {
          $('#listkaryawan_Absensi').hide();
          this.issetPeriode = true;
          $("#modalNullData").modal("show")
        }
      }
    },
    async exportBackground(tryAgain = "") {
      this.ekspor.onprogress = 1
      try {
				let tanggal_awal
				let tanggal_akhir
        switch (this.periode_absen.filter_by) {
          case "periode":
						tanggal_awal = this.periode_absen.start_date
						tanggal_akhir = this.periode_absen.end_date
            break

          case "month":
            let tanggal_awal_month = this.$moment(this.periode_absen.month).startOf("month").format("YYYY-MM-DD")
            let tanggal_akhir_month = this.$moment(this.periode_absen.month).endOf("month").format("YYYY-MM-DD")
						tanggal_awal = tanggal_awal_month
						tanggal_akhir = tanggal_akhir_month
            break
          case "year":
            let tanggal_awal_year = this.$moment(this.periode_absen.year).startOf("year").format("YYYY-MM-DD")
            let tanggal_akhir_year = this.$moment(this.periode_absen.year).endOf("year").format("YYYY-MM-DD")
						tanggal_awal = tanggal_awal_year
						tanggal_akhir = tanggal_akhir_year
            break
          default:
            break
        }

				const query = {
					tanggal_awal: tanggal_awal,
					tanggal_akhir: tanggal_akhir,
					location: Intl.DateTimeFormat().resolvedOptions().timeZone
				}

				const queryString = new URLSearchParams(query).toString();

        const response = await this.$axios.post(this.$baseurl + 'masterData/karyawan/export_logabsen_karyawan?' + queryString, null, this.requestHeaders)
        if (response.status === 200) {
          if (response.data.status === true) {
            let that = this
            this.ekspor.timer = setInterval(function () {
              that.checkExportBackground(that);
            }, 1000)
            // this.deleteStorage(filenameStorage);
          } else {
            this.ekspor.onprogress = 0
          }
        }
      } catch (e) {
        this.ekspor.onprogress = 0
        this.ekspor.progress_looping = 0
        this.ekspor.lenght = 0
        if (tryAgain !== "yes") {
          this.exportBackground("yes")
        } else {
          this.$catch_error_response(e)
        }
      }
    },
    async checkExportBackground(that) {
      try {
        const response = await this.$axios.get(this.$baseurl + 'masterData/karyawan/track_export_logabsen_karyawan', this.requestHeaders)
        if (response.status === 200) {
          if (response.data.status === true) {
            var dataprogress = response.data.data;
            that.ekspor.progress_looping = dataprogress.progress_looping
            that.ekspor.lenght = dataprogress.length_data

            if (dataprogress.status_progress === "1") {
              window.clearInterval(that.ekspor.timer);
              var filenameStorage = response.data.data.filename
              var linkStorage = response.data.data.file_url
              linkStorage = linkStorage.replace(filenameStorage, encodeURIComponent(filenameStorage));
              // window.open(linkStorage, "_blank");
              that.ekspor.exportlink = linkStorage
              setTimeout(function () {
                that.$refs.eksporlink.click()
                setTimeout(function () {
                  that.ekspor.onprogress = 0
                  that.ekspor.progress_looping = 0
                  that.ekspor.lenght = 0
                  // that.deleteStorage(filenameStorage);
                }, 3000)
              }, 1000)
            }
            // that.$forceUpdate()
          } else {
            this.$toast.error(response.data.msg)
            that.ekspor.onprogress = 0
            that.ekspor.progress_looping = 0
            that.ekspor.lenght = 0
          }
        }
      } catch (e) {
        this.$catch_error_response(e)
        that.ekspor.onprogress = 0
        that.ekspor.progress_looping = 0
        that.ekspor.lenght = 0
      }
    },
  }
}
</script>

<style scoped>
.mar-top-185 {
  margin-top: 185px;
}

.pointer-with-nav {
  display: flex;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #206CFF;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  animation: pulse 2s infinite;
  align-content: center;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 70px;
  right: 20px;
}

.image.text-alignC {
  margin-top: 185px;
}

.offanimation {
  animation: none;
}

.card-karyawan {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: .25rem;
}

.animasi-card {
  background: #E2F0FF;
  border-radius: 55px;

}

#loading-bar-spinner.spinner {
  left: 50%;
  margin-left: -20px;
  top: 50%;
  margin-top: -20px;
  position: absolute;
  z-index: 19 !important;
  animation: loading-bar-spinner 400ms linear infinite;
}

#loading-bar-spinner.spinner .spinner-icon {
  width: 40px;
  height: 40px;
  border: solid 4px transparent;
  border-top-color: #a6a9a9 !important;
  border-left-color: #a6a9a9 !important;
  border-radius: 50%;
}

@keyframes loading-bar-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.backgroundSearch {
  position: fixed;
  background-color: #F2F5F7;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.drop_in_plusButton {
  top: -211px !important;
  left: 135px !important;
  transform: none !important;
}

.card-footer {
  padding: 8px 16px;
  border-top: 1px solid #EDEDED;
}

.status-login {
  font-size: 14px;
  background: #E2F0FF;
  border-radius: 50px;
  color: #5F95FF;
  padding: 2px 10px;
}

.status-nonlogin {
  font-size: 14px;
  background: #F3F3F3;
  border-radius: 50px;
  color: #A7A7A7;
  padding: 2px 10px;
}

.overlayLoading {
  position: fixed;
  display: inline;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: white;
  z-index: 99999 !important;
}

.highlight {
  background-color: yellow;
}

.fullpageLoading {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gap-16 {
  gap: 16px;
}
</style>